import React, { useContext } from 'react'
import { getPalette } from '../../styles/palette';
import { StyledThemeContext } from '../../utilities';

const withTheme = (WrappedComponent) => {
    const _withTheme = React.forwardRef((props, ref) => {
        let theme
        const themeContext = useContext(StyledThemeContext);
        if(themeContext && themeContext.primary) {
            theme = themeContext
        } else {
            theme = getPalette()
        }

        return <WrappedComponent {...props} theme={theme} ref={ref} />
    })
    return _withTheme
}

export default withTheme